import userManager from '../Oidc/userManager'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import GymLoading from '../Components/Loading/GymLoading'
import WithUserContext from '../Hoc/WithUserContext'
import IPermissionContextState from 'Models/PermissionContextModel'
import { useEffect } from 'react'
import { deleteBasicData } from 'DataBase/BasicDataDB'
import CacheNames from 'Application/Common/Constants/CacheNames'
import { clearAllCache } from 'DataBase/rtk-persist/cache'
import { COMMON_CACHE_STORE, COMMON_DB_STORE } from 'Services/api/common/common.config'
import {
  ACCOUNT_CACHE_STORE,
  ACCOUNT_DB_STORE,
} from 'Application/Account/services/api/account.config'

type IProps = IPermissionContextState

const SignInCallbackPage = (props: IProps) => {
  const [t] = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    var state = window.location.href?.split('state=')[1]
    localStorage.setItem('code', window.location.href?.split('code=')[1]?.split('&state=')[0])
    var storage = localStorage.getItem(`oidc.${state}`)
    if (storage) {
      var storageData = JSON.parse(storage?.toString())
      localStorage.setItem('code_verifier', storageData.code_verifier)

      userManager
        .signinRedirectCallback()
        .then(user => {
          props.context.setToken(user.access_token, () => {
            var redirectPath = '/'
            const state = user.state as any
            if (state && state.path) redirectPath = state.path as string

            navigate(redirectPath)
          })
        })
        .catch(error => {
          console.log(error)
          userManager.signinRedirect({ state: { path: '/' } })
        })
    } else {
      deleteUserData()
      userManager.signinRedirect({ state: { path: '/' } })
    }
  }, [])
  const deleteUserData = async () => {
    await deleteBasicData(CacheNames.UserAccessList)
    await deleteBasicData(CacheNames.UserProfile)
    await deleteBasicData(CacheNames.InsuranceExpertFieldsCurrentUser)
    await clearAllCache(COMMON_DB_STORE, COMMON_CACHE_STORE)
    await clearAllCache(ACCOUNT_DB_STORE, ACCOUNT_CACHE_STORE)
  }
  return <GymLoading loading={true} description={t('WELCOME')} />
}

export default WithUserContext(SignInCallbackPage)
